import { Edit, Eye, Trash } from "tabler-icons-react";

export const usersHeaders = [
  { id: "id", numeric: true, disablePadding: true, label: "ID" },
  {
    id: "firstName",
    numeric: false,
    disablePadding: true,
    label: "First Name",
  },
  {
    id: "userRole",
    numeric: false,
    disablePadding: true,
    label: "User Type",
  },

  {
    id: "email",
    numeric: false,
    disablePadding: true,
    label: "Email",
  },

  {
    id: "status",
    numeric: false,
    disablePadding: true,
    label: "Status",
  },

  {
    id: "actions",
    view: <Eye />,
    edit: <Edit />,
    // delete: <Trash />,
    numeric: false,
    label: "Actions",
  },
];
